export default __webpack_public_path__ + "static/media/CHM-Logo.f9b33ba5.svg";